import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getDraft, getHasChanges, getSummaryReportId } from "../redux/selectors";
import SummaryReportEditor from "./summaryReportEditor";
const mapStateToProps = (state) => ({
    draft: getDraft(state),
    summaryReportId: getSummaryReportId(state),
    hasChanges: getHasChanges(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    onSaveSummaryReport: (summaryReport) => {
        ownProps.onEditingInProgress && ownProps.onEditingInProgress(true, summaryReport.Id);
        Promise.resolve(dispatch(actionCreators.saveSummaryReport(summaryReport))).then((promiseResult) => {
            var _a;
            ownProps.onEditingInProgress && ownProps.onEditingInProgress(false, summaryReport.Id);
            if (((_a = promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response) === null || _a === void 0 ? void 0 : _a.Id) === undefined)
                return;
            ownProps.onHide && ownProps.onHide(summaryReport.Id);
        });
    },
    onSetDraft: (draft) => dispatch(actionCreators.setDraft(draft))
});
export default connect(mapStateToProps, mapDispatchToProps)(SummaryReportEditor);
